import { SVGProps } from "react";

const EditPencil = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16.005}
    viewBox="0 0 16 16.005"
    {...props}
  >
    <path
      fill={props.color || "#00a5bf"}
      d="M2.4 12.806h3.392a.8.8 0 0 0 .568-.232l5.54-5.545 2.268-2.223a.8.8 0 0 0 0-1.136L10.776.237a.8.8 0 0 0-1.136 0L7.384 2.501 1.832 8.045a.8.8 0 0 0-.232.568v3.393a.8.8 0 0 0 .8.8Zm7.808-10.873 2.264 2.264-1.136 1.136-2.264-2.264ZM3.2 8.941l4.744-4.744 2.264 2.264-4.744 4.745H3.2Zm12 5.464H.8a.8.8 0 1 0 0 1.6h14.4a.8.8 0 1 0 0-1.6Z"
      data-name="774c2b9c14f8465a3d95736caac2a66f"
    />
  </svg>
);
export default EditPencil;
